<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="about-me">关于TA</div>
      <div class="hint">你期望TA的状态？</div> -->
      <img class="pic-about-me" src="https://static.huiyiji520.com/cppic-1661223146.png">
      <img class="pic-hint" src="https://static.huiyiji520.com/cppic-1661233956.png">

      <div class="btn student" @click="chooseJob('student')" :style="{color: getBtnColor('student'), backgroundColor: getBtnBackground('student')}">学生</div>
      <div class="btn worker" @click="chooseJob('worker')" :style="{color: getBtnColor('worker'), backgroundColor: getBtnBackground('worker')}">已工作</div>
      <div class="btn random" @click="chooseJob('random')" :style="{color: getBtnColor('random'), backgroundColor: getBtnBackground('random')}">都可以</div>

      <div class="arrows">
        <div class="signs flex-box">
          <!-- <div class="prev" @click="goBack()"><van-icon name="arrow-left" color="#eb8e80" />上一步</div>
          <div class="next" @click="goNext()">下一步<van-icon name="arrow" color="#eb8e80" /></div> -->
          <img class="pic-prev" @click="goBack()" src="https://static.huiyiji520.com/cppic-1661159773.png">
          <img class="pic-next" @click="goNext()" src="https://static.huiyiji520.com/cppic-1661157292.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Icon } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon
  },
  data(){
    return {
      job: ''
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goNext(){
      if(!this.job){
        Toast('请选择期望TA的状态')
      }else{
        let cpchoose = this.$store.state.cpchoose
        cpchoose.partnerJob = this.job
        this.$store.commit('updateCpChoose', cpchoose)
        this.handleRouter('/choose_partner_surprise')
      }
    },
    chooseJob(job){
      this.job = job
    },
    getBtnColor(job){
      return this.job == job ? '#fff' : '#f1b8af'
    },
    getBtnBackground(job){
      return this.job == job ? '#f1b8af' : '#fff'
    },
    recoverJobs(){
      this.job = this.$store.state.cpchoose.partnerJob ? this.$store.state.cpchoose.partnerJob : this.job
    }
  },
  mounted(){
    this.recoverJobs()
    this.$report.submit('/choose_partner_jobs', this.$store.state.issue, this.$store.state.userinfo.openid)
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661178636.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .about-me{margin-top:200px;margin-bottom:134px;font-size:70px;color:#eb8e80;}
.main .hint{font-size:40px;line-height:40px;color:#eb8e80;margin-bottom:98px;}
.main .pic-about-me{width:239px;height:68px;margin:0 auto;margin-top:208px;margin-bottom:134px;}
.main .pic-hint{width:330px;height:41px;margin:0 auto;margin-bottom:98px;}
.main .btn{
  width:342px;height:110px;line-height:110px;font-size:40px;border:5px solid #f1b8af;border-radius:30px;
  margin:0px auto;color:#f1b8af;background:#fff;
}
.main .btn.worker{margin-top:35px;margin-bottom:35px;}
.main .arrows{position: fixed;bottom:120px;width:100%;}
.main .arrows .signs{
  justify-content:space-between;padding:0px 194px;
  font-size:32px;color:#eb8e80;
}
.main .pic-prev{width:120px;height:32px;}
.main .pic-next{width:120px;height:32px;}
</style>
